import React from "react";
// @ts-expect-error
import { useEffect, useState } from "react";

import PartnerContext, { defaultContextValues, validateContextValues } from "Common/PartnerContext";

type PartnerProviderProps = {
  children?: React.ReactNode;
};

const PartnerProvider = ({ children, partner }: PartnerProviderProps) => {
  const [partnerValues, setPartnerValues] = useState(null);
  useEffect(() => {
    let partnerContextValues;

    switch (true) {
      case window.SIPartnerConfiguration?.injectContextInApps:
        partnerContextValues = window.SIPartnerConfiguration;
        break;

      default:
        partnerContextValues = defaultContextValues;
    }

    setPartnerValues(validateContextValues(partnerContextValues));
  }, []);
  return partnerValues && <PartnerContext.Provider value={partnerValues}>{children}</PartnerContext.Provider>;
};

export default PartnerProvider;
